import { NgModule, ErrorHandler, APP_INITIALIZER } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { InterceptorService } from './services/interceptor.service';
import {
  TelemetryLoggerService,
  CorrelationIdService,
  GlobalErrorHandler,
  setupGlobalErrorListeners,
} from './services/telemetry';
import { environment } from 'src/environments/environment';

/**
 * Factory function to initialize telemetry on app startup
 */
export function initializeTelemetry(
  telemetryLogger: TelemetryLoggerService
): () => Promise<void> {
  return () => {
    // Configure telemetry based on environment
    const telemetryConfig = (environment as any).telemetry || {};
    telemetryLogger.configure({
      enabled: telemetryConfig.enabled !== false,
      fallbackToConsole: telemetryConfig.fallbackToConsole !== false,
    });

    // Setup global error listeners for unhandled promise rejections
    setupGlobalErrorListeners(telemetryLogger);

    return Promise.resolve();
  };
}

@NgModule({
  imports: [CommonModule],
  providers: [
    TelemetryLoggerService,
    CorrelationIdService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptorService,
      multi: true,
    },
    // Register global error handler for uncaught exceptions
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler,
    },
    // Initialize telemetry on app startup
    {
      provide: APP_INITIALIZER,
      useFactory: initializeTelemetry,
      deps: [TelemetryLoggerService],
      multi: true,
    },
  ],
})
export class CoreModule {}
